/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions
} from '@tanstack/react-query'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Update a specific Fund Family to fundraising
 */
export const fundFamilyFundraisingUpdate = (
    fundFamilyId: string,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/fundraise/`, method: 'PATCH'
    },
      options);
    }
  


export const getFundFamilyFundraisingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyFundraisingUpdate>>, TError,{fundFamilyId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof fundFamilyFundraisingUpdate>>, TError,{fundFamilyId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof fundFamilyFundraisingUpdate>>, {fundFamilyId: string}> = (props) => {
          const {fundFamilyId} = props ?? {};

          return  fundFamilyFundraisingUpdate(fundFamilyId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type FundFamilyFundraisingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof fundFamilyFundraisingUpdate>>>
    
    export type FundFamilyFundraisingUpdateMutationError = unknown

    export const useFundFamilyFundraisingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof fundFamilyFundraisingUpdate>>, TError,{fundFamilyId: string}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getFundFamilyFundraisingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    